export default __webpack_public_path__ + "static/media/phone.a13b0a36.svg";